import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { post } from '../Services/http';

const apiEndpoint = '/api/contact-form';


const ContactForm = ({ recaptchaKey, imageUrl, listId, bookAMeetingRecipient }) => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [honeypotField, setHoneypotField] = useState('');
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const clearSession = () => {
    setErrors({})
    setMessage('')
    setSuccess(false)
  }
  const clearForm = () => {
    setEmail('');
    setFirstName('');
    setLastName('');
    setJobTitle('');
    setCaptchaToken('');
    setHoneypotField('');
 
  };
  const onRecaptchaChange = (token) => setCaptchaToken(token);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!email.trim()) {
      newErrors.email = 'We kind of need this';
    } else if (!/\S+@\S+\.\S+/.test(email)) { // Basic email format validation
      newErrors.email = 'Please enter a valid email address';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const formData = {
      email: email,
      firstName: firstName,
      lastName: lastName,
      jobTitle: jobTitle,
      'g-recaptcha-response': captchaToken,
      listId: listId,
      honeypotField: honeypotField,
    };

    try {
      clearSession();
      await post(apiEndpoint, formData);
      setSuccess(true);
      clearForm();
    } catch (error) {
      if (error.response) {
        try {
          const errorData = await error.response.json();
          setMessage(`There was an error: ${errorData.message || 'Unknown error'}`);
        } catch (parseError) {
          setMessage('There was an error submitting your form.');
        }
      } else {
        setMessage('Network error, please try again.');
      }
    }
  };

  return (
    <div>
      {success ? (
        <div className="success-message">
          <h2>Congratulations early adopter!</h2>
          <div className="callout">
            <div className="icon-container">
              <span className="icon-success" aria-hidden="true"></span>
            </div>
          </div>
          <p>Huge thanks for your interest in our production as a service. We’ll let you know as soon as we have
            news.</p>
          <p>Want more?</p>
          <a href={`mailto:${bookAMeetingRecipient}?subject=Book a meeting`} className="button blue">Book a meeting</a>
        </div>
      ) : (
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-title">
            <h2>Sign up to our mailing list to secure early access</h2>
            <p>Open source styles dropping soon</p>
          </div>
          <div className="form-wrapper">
            <div className="image-wrapper">
              <img alt="image" src={imageUrl} />
            </div>
            <div className="form-content">
              <label>
                Email
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={errors.email ? 'error' : ''}
                  placeholder="yourname@example.com"
                  required
                />
                {errors.email && <div className="error-message">{errors.email}</div>}
              </label>

              <label>First Name *
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="Enter your first name"
                />
              </label>

              <label>Last Name *
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Enter your last name"
                />
              </label>

              <label>Job Title *
                <input
                  type="text"
                  value={jobTitle}
                  onChange={(e) => setJobTitle(e.target.value)}
                  placeholder="E.g., Buyer, Manager, Designer"
                />
              </label>

              <label className="title">Title *
                <input
                  type="text"
                  value={honeypotField}
                  onChange={(e) => setHoneypotField(e.target.value)}
                  placeholder="E.g., Bee, Or, Not, Bee, Bzzz"
                />
              </label>

              <p className="if-you-want">* If you want</p>

              {/*<ReCAPTCHA sitekey={recaptchaKey} onChange={onRecaptchaChange} />*/}

              <button type="submit" className="button blue">Sign up</button>
              {message && <div className="form-message">{message}</div>}
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default ContactForm;